import { Component, ChangeDetectionStrategy, inject, signal, DestroyRef, HostListener, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CartService } from '../../../core/services/shared/cart.service';
import { NAV_ITEMS } from '../../../core/config/navigation.config';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-header',
    standalone: true,
    imports: [CommonModule, RouterModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent {
    private router = inject(Router);
    cartService = inject(CartService);
    private platformId = inject(PLATFORM_ID);
    navItems = NAV_ITEMS;

    isScrolled = signal(false);
    isHome = signal(false);
    isMenuOpen = false;

    constructor() {
        // Detect initial route
        this.updateHomeStatus();

        // Listen to route changes
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            takeUntilDestroyed()
        ).subscribe(() => {
            this.updateHomeStatus();
            this.isMenuOpen = false; // Close mobile menu on navigation
        });
    }

    private updateHomeStatus() {
        // More robust home detection
        const url = this.router.url.split('?')[0];
        this.isHome.set(url === '/' || url === '' || url === '/home');
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        if (isPlatformBrowser(this.platformId)) {
            const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || 0;
            this.isScrolled.set(scrollPosition > 20);
        }
    }

    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
}
